define('PriceMatch.Model',
  [
    'Backbone.Model',
    'Utils'
  ],
  function (
    BackboneModel,
    Utils
  ) {
    'use strict';

    return BackboneModel.extend({
      urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/PriceMatch.Service.ss'))
    });
  });
